import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

const ShareButton = ({ caption, action, separatorLeft }) => {
  return (
    <button
      className={
        separatorLeft
          ? 'share-button share-button--separator-left'
          : 'share-button'
      }
      onClick={action}
    >
      <span className="share-button__text">{caption}</span>
      <FontAwesomeIcon
        icon={faShare}
        size="sm"
        className="share-button__icon"
      />
    </button>
  );
};

ShareButton.propTypes = {
  caption: PropTypes.string,
  separatorLeft: PropTypes.bool,
  action: PropTypes.func,
};

export default ShareButton;
